import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
    isAdmin: false,
    adminMode: false
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_ADMIN:
            return updateObject(state, { isAdmin: action.isAdmin, adminMode: false });
        case actionTypes.TOGGLE_ADMIN_MODE:
            return updateObject(state, { adminMode: !state.adminMode });
        default:
            return state;
    }
};

export default reducer;
